import { Component, Input, OnInit } from '@angular/core';
import { SANCTION_LABELS } from '@app/ps/models/subject-detail.model';

@Component({
  selector: 'sanction-badge',
  templateUrl: './sanction-badge.component.html',
  styleUrls: ['./sanction-badge.component.scss'],

})
export class SanctionBadgeComponent implements OnInit {
  @Input() detail: any;

  hasAnySanction = false;
  isDisputed = false;
  baseTitle = '';
  fullTitle = '';

  constructor() {
  }

  ngOnInit(): void {
    if (!this.detail) {
      this.hasAnySanction = false;
      return;
    }

    const {
      ssEU, ssNonEU, ssRuskyVliv,
      ssZpochybneni, ssZpochybneniRSD,
      ssDoporuceni, ssZpochybneniDuvod, ssZpochybneniRSDDuvod,
    } = this.detail;

    this.hasAnySanction = !!(ssEU || ssNonEU || ssRuskyVliv);
    this.isDisputed = !!(ssZpochybneni || ssZpochybneniRSD);

    const parts: string[] = [];
    if (ssEU) { parts.push(SANCTION_LABELS.EU); }
    if (ssNonEU) { parts.push(SANCTION_LABELS.NON_EU); }
    if (ssRuskyVliv) { parts.push(SANCTION_LABELS.RUSSIAN_INFLUENCE); }
    this.baseTitle = parts.join(', ').toUpperCase();

    const source =
      ssZpochybneni && ssZpochybneniRSD ? 'DATLAB / ŘSD' :
        ssZpochybneni ? 'DATLAB' :
          ssZpochybneniRSD ? 'ŘSD' :
            '';

    const titleBase = source
      ? `${this.baseTitle} - Uvedení v seznamu je zpochybněno (${source})`
      : this.baseTitle;

    const sections = [
      { label: 'Doporučení:', value: ssDoporuceni },
      { label: 'Důvod zpochybnění:', value: ssZpochybneniDuvod },
      { label: 'Důvod zpochybnění ŘSD:', value: ssZpochybneniRSDDuvod },
    ];
    const blocks = sections
      .filter(s => s.value)
      .map(s => `${s.label}\n${s.value}`);

    this.fullTitle = blocks.length > 0
      ? `${titleBase}\n\n${blocks.join('\n')}`
      : titleBase;
  }
}
